// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3wq3A","notes":"Notes_notes__WDdIE","note":"Notes_note__1DGry","markdown":"Notes_markdown__1-UVQ"};